import { FC } from "react";

import Box, { BoxProps } from "@mui/material/Box";

import { ITEMS } from "./config";

import Heading from "sections/nfcTagsPage/Heading";

import Tweets from "components/Tweets";

interface ReviewsSectionProps {
  boxProps?: BoxProps;
}

const ReviewsSection: FC<ReviewsSectionProps> = ({ boxProps }) => {
  return (
    <Box component="section" {...boxProps}>
      <Heading
        heading="FEEDBACK WE LOVE"
        subheading="Made to extend the user experience to the deepest level."
      />

      <Tweets items={ITEMS} defaultItems={ITEMS.length} />
    </Box>
  );
};

export default ReviewsSection;
